import React, { Component } from "react";
import "../styles/info.scss";
import Snackbar from "@material-ui/core/Snackbar";
import CopyIcon from "../../NewCalls/img/content_copy.svg";

const Info = ({ header, body, copyMsg }) => {
  return (
    <div className="referral-card-info">
      <div className="header">{header}</div>
      <div className="body">
        {<p>{body}</p>}
        {copyMsg && <CopyInfo message={copyMsg} info={body} />}
      </div>
    </div>
  );
};

const CopyInfo = ({ message, info }) => {
  const [open, setOpen] = React.useState(false);

  const handleClick = () => {
    navigator.clipboard.writeText(info);
    setOpen(true);
  };

  const handleClose = (event) => {
    setOpen(false);
  };

  return (
    <div className="copy-clipboard">
      <img src={CopyIcon} onClick={handleClick} />
      <Snackbar
        anchorOrigin={{
          vertical: "top",
          horizontal: "center",
        }}
        autoHideDuration={3000}
        open={open}
        onClose={handleClose}
        message={`${message} ${info} is copied to clipboard`}
        key={"top_center_snackbar"}
      />
    </div>
  );
};

export default Info;
